<template>
  <div class="home">
    <div class="header">
      <h1>
        <a
          href="//scjg.hubei.gov.cn/index.shtml"
          class="nt"
          style="width: 100%"
          title=""
        ></a>
      </h1>
      <el-form :model="queryForm" label-width="150px">
        <el-row type="flex" style="flex-wrap: wrap">
          <el-col :xs="24" :sm="6">
            <el-form-item label="身份证号：">
              <el-input
                v-model="queryForm.zsbh"
                placeholder="请输入身份证号"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="姓名：">
              <el-input
                v-model="queryForm.xm"
                placeholder="请输入姓名"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="4">
            <el-button @click="clickQuery" type="primary" style="width: 40%"
              >查 询</el-button
            >
            <el-button @click="resetQuery" type="info" style="width: 40%"
              >重 置</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="header-title">
      <p>大型游乐设施作业人员信息查询</p>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        :header-cell-style="{ background: '#e5f3ff', color: '#305099' }"
      >
        <el-table-column prop="XM" label="姓名" align="center">
        </el-table-column>
        <el-table-column prop="ZSBH" label="证书编号" align="center">
        </el-table-column>
        <el-table-column
          prop="FZJG"
          label="发证机构"
          width="300"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="PZRQ"
          label="批准日期"
          width="300"
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" width="300" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="btnClick(scope.row)"
              >电子证书</el-button
            >
          </template>
        </el-table-column>
        <template slot="empty"> 未查询到数据 </template>
      </el-table>
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :total="pageTotal"
      :current-page="queryPage.currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="queryPage.pageSize"
      layout="prev, next"
    >
    </el-pagination>
    <iframe
      src="https://scjg.hubei.gov.cn/fzlm/qtlm/yw/index.shtml"
      frameborder="0"
      style="width: 100%; height: 202px"
    ></iframe>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import http from "@/http/index.js";
export default {
  name: "Home",
  // components: {
  //   HelloWorld
  // }
  data() {
    return {
      queryForm: {
        xm: "",
        // tyshxydm: '',
        // fzjg: '',
        zsbh: "",
      },
      queryPage: {
        currentPage: 1,
        pageSize: 10,
      },
      tableData: [],
      pageTotal: 0,
      zsmc: "",
      isParmasQuery: false,
    };
  },
  created() {},
  mounted() {
    this.initQury();
  },
  methods: {
    // 初始化查询
    async initQury() {
      this.isParmasQuery = false;
      const req = {
        pageSize: this.queryPage.pageSize,
        currentPage: this.queryPage.currentPage,
        zyzl: "大型游乐设施作业",
      };
      const param = JSON.stringify(req);
      const findDgsLicListResp = await http.user.findDgsLicList({
        param,
        method: "POST",
      });
      const { code, content, totalSize } = await http.user.licmaininfo(
        req,
        findDgsLicListResp
      );
      // code有数字和true的情况
      if (code == true || code == 200) {
        this.tableData = content;
        this.pageTotal = totalSize;
      }
    },
    // 分页
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.queryPage.pageSize = val;
      if (!this.isParmasQuery) {
        this.initQury();
      } else {
        this.queryPamarSwarch();
      }
    },
    // 分页
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.queryPage.currentPage = val;
      if (!this.isParmasQuery) {
        this.initQury();
      } else {
        this.queryPamarSwarch();
      }
    },
    // 重置查询
    resetQuery() {
      this.queryPage = this.$options.data().queryPage;
      this.queryForm = this.$options.data().queryForm;
      this.initQury();
    },
    // 按钮事件
    btnClick(data, type) {
      this.$alert(
        "根据网络安全管理要求，暂无法查看电子证书。待系统优化后可再查询。不便之处，敬请谅解！",
        "提示",
        {
          confirmButtonText: "确定",
          callback: (action) => {
          },
        }
      );
      return;
      window.open(data.ZB);
    },
    // 点击查询初始化
    async queryPamarSwarch() {
      const req = {
        // zsmc: this.zsmc,
        pageSize: this.queryPage.pageSize,
        currentPage: this.queryPage.currentPage,
        zsbh: this.queryForm.zsbh,
        xm: this.queryForm.xm,
        zyzl: "大型游乐设施作业",
      };

      const param = JSON.stringify(req);
      const findDgsLicListResp = await http.user.findDgsLicList({
        param,
        method: "POST",
      });
      const { code, content, totalSize } = await http.user.licmaininfobyparam(
        req,
        findDgsLicListResp
      );
      if (code == true || code == 200) {
        this.tableData = content;
        this.pageTotal = totalSize;
      }
    },
    // 点击查询
    async clickQuery() {
      this.isParmasQuery = true;
      this.queryPage.pageSize = 10;
      this.queryPage.currentPage = 1;
      this.queryPamarSwarch();
    },
  },
};
</script>
<style scoped>
.header {
  margin-top: 50px;
}
.header h1 {
  width: 600px;
  height: 150px;
  background: url(https://scjg.hubei.gov.cn/material/images/logo.png) 0 50%
    no-repeat;
  background-size: 60%;
}

.header h1 a {
  display: block;
  height: 150px;
  background: transparent !important;
}

.nt {
  text-align: left;
  letter-spacing: -3em;
  overflow: hidden;
}

.header-title {
  font-size: 17pt;
  font-weight: 600;
  margin-top: 30px;
  color: rgb(19, 90, 156);
}

.table {
  margin-top: 50px;
  margin-bottom: 50px;
  width: 100%;
}
/* ::deep .el-table__fixed-header-wrapper{
    background-color: #e5f3ff;
} */
</style>
